module.exports = __webpack_public_path__ + "static/media/icon.0b6ee9c8.svg";